import { SVGProps } from 'react';

const IterationCcw = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m16 22 4-4-4-4m4 4h-8a8 8 0 1 1 8-8"
    />
  </svg>
);
export default IterationCcw;
